import type { FaireProductEntity } from "../../entity_types/product";

export const p_nd44hn8rnk: FaireProductEntity = {
  token: "p_nd44hn8rnk",
  type: "product",
  name: "Ginger Non-Alcoholic Kombucha",
  brandToken: "b_s2jesyk5p9",
  brandName: "Walker Brothers",
  imageUrl: "https://cdn.faire.com/fastly/654859edc5946ce355518d057ff0e31a46cbbdfb8890e64a3dbc56a042d81030.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/edfd29ae8cf68cb070e571ceb1a8f2b3836654aecbe75a5c79a9991a20b9df1e.jpeg",
    "https://cdn.faire.com/fastly/adbd2b291ff8c6ea32bfa4b69f85075f55a86fd7a9de96395f467c3f5b1b0a99.jpeg",
    "https://cdn.faire.com/fastly/d12183bae8856112a7c31496bc8226755436f29c018a94577c7cea461a7e41f6.png",
    "https://cdn.faire.com/fastly/0bad2c0e6eee8bb7e6c2eef115652446dc01e7a85586cd30eaf6bb1b9bdd4ed8.jpeg",
    "https://cdn.faire.com/fastly/821d0889de6c537cfd08557085c7b14172933c4465f1a419816026c1bd148f6c.jpeg",
    "https://cdn.faire.com/fastly/813b40e134af8ba186287b66fea36a36bc330de77fd65ff69fe8c24ae0031268.png"
  ],
  priceDollars: 2.25,
  description: "Cold-pressed Peruvian ginger root combines with our signature blend of black, green, and jasmine teas in this craft non-alcoholic kombucha to create a subtly spicy flavor, with a mildly sweet, yet tart, finish. \n\n***Please note: This item must be kept refrigerated.***\n\nIngredients: Raw Kombucha (Filtered Water, Kombucha Culture, Black Tea*, Green Tea*, Jasmine Tea*, Cane Sugar*), Fresh Pressed Ginger Juice*\n*certified organic ingredients\n\nWalker Brothers Ginger craft kombucha is non-alcoholic, unpasteurized and rich in live probiotics, gluten-free, kosher pareve, and vegan.\n\nPackaged in an aluminum can for ease of recycling \n\n\n\n\n\n\n\nA healthy, non-alcoholic option for fall gatherings, tailgates, Halloween, Thanksgiving, Friendsgiving and holiday parties! A great mixer for drinks as well as a good snack pairing with chips and popcorn. ",
  tags: [],
  msrpDollars: 4.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:41.278Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
